const logos = [
  { src: '/assets/img/logo-roo.webp', alt: 'Roo Festival' },
  { src: '/assets/img/logo-firefly.webp', alt: 'Firefly Music Festival' },
  { src: '/assets/img/logo-forbidden-kingdom.webp', alt: 'Forbidden Kingdom Festival' },
  { src: '/assets/img/logo-lost-lands.webp', alt: 'Lost Lands Festival' },
];

// Repeat the set enough to exceed any viewport width, then duplicate it so the
// CSS marquee can translate by exactly one half for a seamless, gap-free loop.
const oneSet = Array.from({ length: 4 }, () => logos).flat();
const track = [...oneSet, ...oneSet];

export default function Testimonials() {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-widest text-teal-600 font-semibold mb-3">Trusted By</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">Our Happy Clients</h2>
          <p className="text-gray-400 text-base">
            Proud to work with some of the world&apos;s best events &amp; festivals
          </p>
        </div>
      </div>

      {/* Full-width seamless scrolling strip (full colour, never stops) */}
      <div className="relative w-full overflow-hidden">
        <div className="flex w-max items-center ppt-marquee">
          {track.map((logo, i) => (
            <div
              key={i}
              className="flex items-center justify-center flex-shrink-0 mx-8"
              style={{ width: '160px', height: '72px' }}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes pptMarquee {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        .ppt-marquee {
          animation: pptMarquee 80s linear infinite;
          will-change: transform;
        }
      `}</style>
    </section>
  );
}
